import { ApolloLink } from 'apollo-link';
import moment from 'moment';
import { Logger } from '../../telemetry/Logger';
import {
  ScenarioColumns,
  TelemetryScenarioErrorStatus,
  TelemetryScenarioStatus
} from '../../telemetry/TelemetryScenarioTracker.types';

export const createTelemetryLink = () =>
  new ApolloLink((operation, forward) => {
    const { operationName } = operation;
    const startTime = moment();

    operation.setContext({ startTime: startTime });

    if (forward) {
      return forward(operation).map(response => {
        const endTime = moment();
        const elapsedTimeInMs = moment
          .duration(endTime.diff(startTime))
          .asMilliseconds();

        const context = operation.getContext();

        const responseObject = context?.response;
        const responseHeaders = responseObject?.headers;

        const correlationId = responseHeaders?.get('x-ms-correlationid');
        const error = response?.errors?.[0] ?? undefined;

        Logger.logMiddleTierRequestScenario({
          operation: operationName,
          [ScenarioColumns.CorrelationId]: correlationId,
          elapsed: elapsedTimeInMs,
          [ScenarioColumns.ScenarioStatus]: error
            ? TelemetryScenarioStatus.Failure
            : TelemetryScenarioStatus.Success,
          errorCode: error ? TelemetryScenarioErrorStatus.Error : undefined,
          error
        });

        return response;
      });
    } else {
      return null;
    }
  });
